// "Why is this file live or history?" — one compact pill from journey.live / live_kind / live_reason (Dean, 15 Oct 2026).
import { Activity, Archive, BrushCleaning, History } from "lucide-react";

const META = {
  live:    { label: "Live",     Icon: Activity, tone: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  tidy_up: { label: "Tidy up",  Icon: BrushCleaning,    tone: "bg-amber-50 text-amber-900 border-amber-300" },
  history: { label: "History",  Icon: History,  tone: "bg-slate-50 text-slate-600 border-slate-200" },
  closed:  { label: "Closed",   Icon: Archive,  tone: "bg-slate-100 text-slate-600 border-slate-300" },
  none:    { label: "No legal", Icon: History,  tone: "bg-slate-50 text-slate-500 border-slate-200" },
};

export function LivePill({ journey, caseId, muted = false, full = false, className = "" }) {
  if (!journey || !journey.live_kind) return null;
  const m = META[journey.live_kind] || META.history;
  if (muted && journey.live) return null;   // on the Live legal list every row is live — no need to say so
  const Icon = m.Icon;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded border max-w-full ${m.tone} ${className}`}
      title={journey.live_reason} data-testid={`live-pill-${journey.live_kind}${caseId ? `-${caseId}` : ""}`}>
      <Icon className="w-2.5 h-2.5 shrink-0" />
      <span className="uppercase tracking-wide">{m.label}</span>
      {full && <span className="font-normal normal-case tracking-normal truncate" data-testid="live-pill-reason">· {journey.live_reason}</span>}
    </span>
  );
}
